/**
 * @class VariantSelects
 * @extends HTMLElement
 * @param {String} product-id - The product id.
 * @param {String} section-id - The section id.
 * @returns {void}
 */
class VariantSelects extends HTMLElement {
  /** @type {String | null} */
  productId = this.getAttribute('product-id') || null;

  /** @type {String | null} */
  sectionId = this.getAttribute('section-id') || null;

  // Run methods when the element connects to the DOM
  connectedCallback() {
    // Listen to variant changes
    this.addEventListener('change', this.onVariantChange);

    // Get the current variant data and set as current variant
    this.getSelectedVariantOptions();
  }

  onVariantChange() {
    // Get the selected variant options
    this.getSelectedVariantOptions();

    // Get the current variant data and set as current variant
    this.currentVariant = this.getCurrentVariantData();

    if (this.currentVariant) {
      // Update the input with the new variant id
      this.updateVariantInput();

      // Dispatch the variant change event
      this.dispatchVariantChange();
    }
  }

  // Get the current selected variant options from the selects
  getSelectedVariantOptions() {
    console.log('> getSelectedVariantOptions');
    this.variantOptions = Array.from(this.querySelectorAll('select'), (select) => select.value);
    console.log('this.variantOptions');
    console.log(this.variantOptions);
  }

  // Update the current variant based on the selected options
  getCurrentVariantData() {
    return this.getProductVariantsData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          if (!this.variantOptions[index]) {
            return true;
          }
          return this.variantOptions[index] === option;
        })
        .includes(false);
    });
  }

  // Dispatch the variant change event
  dispatchVariantChange() {
    this.loading();
    this.dispatchEvent(
      new CustomEvent('variant-change', {
        bubbles: true,
        detail: {
          variant: this.currentVariant,
          product: this.productId,
          section: this.sectionId,
        },
      })
    );
  }

  // Update the input with the new variant id
  updateVariantInput() {
    this.idInput = this.idInput || this.querySelector('input[name="id"]');
    this.idInput.value = this.currentVariant.id;
  }

  // Get the variant data from the JSON script tag
  getProductVariantsData() {
    this.variantData =
      this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  loading(state = true) {
    this.querySelector('[data-loading]')?.setAttribute('aria-hidden', !state);
  }
}

customElements.define('variant-selects', VariantSelects);
